import { render, staticRenderFns } from "./EstimateRow.vue?vue&type=template&id=8f9a1874&scoped=true&"
import script from "./EstimateRow.vue?vue&type=script&lang=ts&"
export * from "./EstimateRow.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateRow.vue?vue&type=style&index=0&id=8f9a1874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a1874",
  null
  
)

export default component.exports